import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
const meetingTypesContentLoaderCss = "m1elyzne";
const meetingTypesLoaderOverlayCss = "mmny62a";
export const MeetingTypesContentLoader = ({
  overlay = false
}) => <div className={classNames(overlay ? meetingTypesLoaderOverlayCss : meetingTypesContentLoaderCss)} data-testid="scheduling-meeting-types-loader" data-loader-source="scheduling-meeting-types" aria-busy="true">
    <Loader data-testid="loader" data-loader-source="scheduling-meeting-types" />
  </div>;

require("./content_loader.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./content_loader.js");